/**
 * Trainer → student broadcast when the live session ends.
 */

export const LIVE_SESSION_ENDED_TYPE = "codelive.session-ended" as const;

export type LiveSessionEndedMessage = {
  type: typeof LIVE_SESSION_ENDED_TYPE;
  v: 1;
  message?: string;
};

export function encodeLiveSessionEnded(
  msg: Omit<LiveSessionEndedMessage, "type" | "v"> = {},
): Uint8Array<ArrayBuffer> {
  const payload: LiveSessionEndedMessage = {
    type: LIVE_SESSION_ENDED_TYPE,
    v: 1,
    ...msg,
  };
  return new TextEncoder().encode(
    JSON.stringify(payload),
  ) as Uint8Array<ArrayBuffer>;
}

export function decodeLiveSessionEnded(
  data: Uint8Array,
): LiveSessionEndedMessage | null {
  try {
    const raw = JSON.parse(new TextDecoder().decode(data)) as Partial<
      LiveSessionEndedMessage
    >;
    if (raw?.type !== LIVE_SESSION_ENDED_TYPE || raw.v !== 1) return null;
    return {
      type: LIVE_SESSION_ENDED_TYPE,
      v: 1,
      message:
        typeof raw.message === "string" && raw.message.trim()
          ? raw.message.trim()
          : undefined,
    };
  } catch {
    return null;
  }
}
